import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http';

import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import * as _ from 'lodash';
import { Router } from '@angular/router';

import { Product } from '../../common/models/product';
import { Payment, TransactionStatus, PaymentRegistration, CapturePaymentStatus } from '../../common/models/payment';
import { mockupProducts } from '../../common/config/mokup-data';
import { PaymentInformation, CardInformation, OrderInformation, TerminalInformation } from '../../common/models/paymentInfo';
import { PaymentHistoryLog } from '../../common/models/PaymentHistoryLog';
import { User } from './../../common/models/user';

import { PaymentStatus } from '../../common/models/paymentStatus';
import { SessionManager } from '../../common/helpers/session-manager';
import { Order } from '../../common/models/order';
import { Member } from '../../common/models/member';

import { AppLoggingService } from '../../common/services/AppLogging.service';

@Injectable()
export class PaymentService {

    promotionProducts: Product[] = [];
    paymentLog = new PaymentHistoryLog();

    constructor(private router: Router, private http: Http, private sessionManager: SessionManager, private log: AppLoggingService) {
    }

    registerPayment(orderNo: string, currencyCode: string, amount: number, customerId: string, customerEmail: string,
        promoCode: string, sessionId: string): Observable<any> {

        const paymentRegistrationUrl = environment.host + '/api/payment/redirectToPaymentGateway';

        const paymentRegistration = new PaymentRegistration();
        paymentRegistration.orderNo = orderNo;
        paymentRegistration.currencyCode = currencyCode;
        paymentRegistration.amount = Math.floor(amount);
        paymentRegistration.customerId = customerId;
        paymentRegistration.customerEmail = customerEmail;
        paymentRegistration.promoCode = promoCode;
        paymentRegistration.sessionId = sessionId;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(paymentRegistrationUrl, paymentRegistration, options)
            .map((response: any) => {

                console.log(response.json());

                const paymentStatus = new PaymentStatus();
                paymentStatus.status = '2';
                this.sessionManager.setPaymentStatus(paymentStatus);

                window.location.href = response.json();
            })
            .catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    registerRecuringPayment(orderNo: string, currencyCode: string, amount: number, customerId: string, customerEmail: string,
        promoCode: string, sessionId: string): Observable<any> {

        const paymentRegistrationUrl = environment.host + '/api/payment/RedirectToPaymentGatewayRecurring';

        const paymentRegistration = new PaymentRegistration();
        paymentRegistration.orderNo = orderNo;
        paymentRegistration.currencyCode = currencyCode;
        paymentRegistration.amount = Math.floor(amount);
        paymentRegistration.customerId = customerId;
        paymentRegistration.customerEmail = customerEmail;
        paymentRegistration.promoCode = promoCode;
        paymentRegistration.sessionId = sessionId;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(paymentRegistrationUrl, paymentRegistration, options)
            .map((response: any) => {

                console.log(response.json());

                const paymentStatus = new PaymentStatus();
                paymentStatus.status = '2';
                this.sessionManager.setPaymentStatus(paymentStatus);

                window.location.href = response.json();
            })
            .catch((e: any) => Observable.throw(this.errorHandler(e)));
    }

    postAuthorizationForPayment(transactionId: string, statusCode: string, orderNo: string, amount: number, customerId: string,
        customerEmail: string, promoCode: string, sessionId: string): Observable<any> {
        // TODO Payment processing started AUTH
        const captureInfo = new CapturePaymentStatus();
        const authUrl = environment.host + '/api/payment/authorizePayment';

        this.promotionProducts = JSON.parse(localStorage.getItem('promotionProductsIds'));

        captureInfo.transactionId = transactionId;
        captureInfo.responseCode = statusCode;
        captureInfo.orderId = orderNo;
        captureInfo.amount = amount;
        captureInfo.customerId = customerId;
        captureInfo.customerEmail = customerEmail;
        captureInfo.promoCode = promoCode;
        captureInfo.sessionId = sessionId;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(authUrl, captureInfo, options)
            .map((response: any) => {

                const result = response.json();

                const paymentStatus = new PaymentStatus();
                paymentStatus.status = result.statusId;
                paymentStatus.transactionId = result.transactionId;
                this.sessionManager.setPaymentStatus(paymentStatus);

                return result;
            });
    }

    capturePayment(transactionId: string, statusCode: string, orderNo: string, amount: number, customerEmail: string,
        promoCode: string, customerId: string, sessionId: string): Observable<any> {
        // TODO Payment processing started CAPTURE

        const captureInfo = new CapturePaymentStatus();
        const authUrl = environment.host + '/api/payment/capturePayment';

        this.promotionProducts = JSON.parse(localStorage.getItem('promotionProductsIds'));

        captureInfo.transactionId = transactionId;
        captureInfo.responseCode = statusCode;
        captureInfo.orderId = orderNo;
        captureInfo.amount = amount;
        captureInfo.customerId = customerId;
        captureInfo.customerEmail = customerEmail;
        captureInfo.promoCode = promoCode;
        captureInfo.sessionId = sessionId;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(authUrl, captureInfo, options)
            .map((response: any) => {
                const result = response.json();
                const paymentStatus = new PaymentStatus();
                paymentStatus.status = result.statusId;
                paymentStatus.transactionId = result.transactionId;
                this.sessionManager.setPaymentStatus(paymentStatus);
                return result;
            });
    }

    postTransactionStatus(transactionId: string, statusCode: string, customerId: string, customerEmail: string, promoCode: string,
        sessionId: string): Observable<any> {

        const transactionStatus = new TransactionStatus();
        transactionStatus.transactionId = transactionId;
        transactionStatus.responseCode = statusCode;
        transactionStatus.customerId = customerId;
        transactionStatus.customerEmail = customerEmail;
        transactionStatus.promoCode = promoCode;
        transactionStatus.sessionId = sessionId;

        const transactionStatusModel = JSON.stringify(transactionStatus);
        const transactionStatusUrl = environment.host + '/api/payment/getTransactionDetails';

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(transactionStatusUrl, transactionStatusModel, options)
            .map((response: any) => {
                const result = response.json();

                const orderInfoObj = new OrderInformation();
                orderInfoObj.Amount = result.orderInfo.amount;
                orderInfoObj.Currency = result.orderInfo.currency;
                orderInfoObj.Fee = result.orderInfo.fee;
                orderInfoObj.OrderDescription = result.orderInfo.orderDescription;
                orderInfoObj.OrderNumber = result.orderInfo.orderNumber;
                orderInfoObj.RoundingAmount = result.orderInfo.roundingAmount;
                orderInfoObj.Total = result.orderInfo.total;
                orderInfoObj.TimeStamp = result.orderInfo.timestamp;

                const cardInfoObj = new CardInformation();
                cardInfoObj.PaymentMethod = result.paymentMethod.paymentMethod;

                const terminalInfoObj = new TerminalInformation();
                terminalInfoObj.Browser = result.terminalInformation.browser;
                terminalInfoObj.CustomerEntered = result.terminalInformation.customerEntered;
                terminalInfoObj.CustomerRedirected = result.terminalInformation.customerRedirected;

                const paymentInfoObj = new PaymentInformation();
                paymentInfoObj.QueryFinished = result.queryFinished;
                paymentInfoObj.ErrorLog = result.errorLog;
                paymentInfoObj.ErrorMessage = result.errorMessage;

                paymentInfoObj.OrderInfo = orderInfoObj;
                paymentInfoObj.PaymentMethod = cardInfoObj;
                paymentInfoObj.TerminalInformation = terminalInfoObj;

                const paymentStatus = new PaymentStatus();
                paymentStatus.status = result.statusId;
                paymentStatus.transactionId = result.transactionId;

                this.sessionManager.setPaymentStatus(paymentStatus);

                if (result.terminalInformation.customerRedirected == null) {
                    this.router.navigate(['paymenterrormessage']);

                } else {
                    return paymentInfoObj;
                }
            });
    }

    CreateInvoiceAndCreditNote(customerId: string): Observable<any> {
        const createInvoiceUrl = environment.host + '/api/payment/createInvoiceAndCreditNote';

        const paymentRegistration = new PaymentRegistration();
        paymentRegistration.customerId = customerId;

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');

        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(createInvoiceUrl, paymentRegistration, options)
            .map((response: any) => {
                const variable = response;
                window.location.href = response.json();
            });
    }

    sendReceipt(customerDetails: any, orderDetails: any, invoiceID: number, sessionId: string): Observable<any> {

        const receiptEmailUrl = environment.host + '/api/email/sendReceipt';
        const headers = new Headers();
        const receiptData = {
            customerId: customerDetails,
            orderDetails: orderDetails,
            invoiceId: invoiceID,
            subject: 'Tusen takk',
            fromAddress: 'firmapost@embla.no',
            sessionId: sessionId
        };

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(receiptEmailUrl, receiptData, options).map((response: any) => {
            const variable = response.json();
            return variable;
        });
    }

    sendWelcomeEmail(welcomeEmailDetails: any, sessionId: string): Observable<any> {

        const data = {
            PaymentHistoryLog: {
                customerId: welcomeEmailDetails.customerDetails.id,
                transactionId: welcomeEmailDetails.transactionId,
                orderId: welcomeEmailDetails.orderDetails.orderId,
                amount: welcomeEmailDetails.orderDetails.orderTotal,
                total: welcomeEmailDetails.orderDetails.orderTotal,
                email: welcomeEmailDetails.customerDetails.email,
                promoCode: welcomeEmailDetails.promotionCode
            },
            subject: 'Velkommen',
            fromAddress: 'firmapost@embla.no',
            sessionId: sessionId
        };

        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(environment.host + '/api/email/sendWelcome', data, options).map((response: any) => {
        });
    }

    setProvisions(customerId: AAGUID, shoppingCartDetails: Order, promoCode: string, userDetails: User,
        transactionId: string, sessionId: string): Observable<any> {
        const paymentRegistrationUrl = environment.host + '/api/payment/setProvisions';
        const headers = new Headers();

        this.paymentLog.customerId = customerId;
        this.paymentLog.orderId = shoppingCartDetails.orderId;
        this.paymentLog.amount = shoppingCartDetails.orderTotal;
        this.paymentLog.email = userDetails.email;
        this.paymentLog.promoCode = promoCode;
        this.paymentLog.transactionId = transactionId;

        const provisionData = {
            customerId: customerId,
            email: userDetails.email,
            paymentHistoryLog: this.paymentLog,
            sessionId: sessionId
        };

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });
        return this.http.post(paymentRegistrationUrl, provisionData, options).map((response: any) => {
            const result = response.json();
            console.log(result);
            return result;
        });
    }

    errorHandler(error: any) {
        this.log.errorCode = error.json();
        this.router.navigate(['alert']);
    }

    processOffer(promoCode: string, customerId: string, orderDetails: any, transactionId: string, sessionId: string, invoiceNumber: string, welcomeEmailSub: string,
        thankyouEmailSub: string, customerEmail: string)
        : Observable<any> {
        const paymentRegistrationUrl = environment.host + '/api/payment/ProcessOffer';
        const headers = new Headers();

        const offerData = {
            offerCode: promoCode,
            customerId: customerId,
            orderDetails: orderDetails,
            transactionId: transactionId,
            sessionId: sessionId,
            invoiceID: invoiceNumber,
            welcomeEmailSub: welcomeEmailSub,
            thankyouEmailSub: thankyouEmailSub,
            customerEmail: customerEmail
        };

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(paymentRegistrationUrl, offerData, options).map((response: any) => {

            const result = response.json();
            return result;
        });
    }

    savePanHash(promoCode: string,
                customerId: string,
                orderNumber: string,
                transactionId: string,
                sessionId: string,
                productPriceListiItem: string,
                customerEmail: string)
        : Observable<any> {
        const paymentRegistrationUrl = environment.host + '/api/payment/addRecuringPayment';
        const headers = new Headers();
        debugger;
        const offerData = {
            promoCode: promoCode,
            customerId: customerId,
            orderNo: orderNumber,
            transactionNo: transactionId,
            customerEmail: customerEmail,
            sessionId: sessionId,
            productPriceListItem: productPriceListiItem
        };

        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        const options = new RequestOptions({ headers: headers, withCredentials: true });

        return this.http.post(paymentRegistrationUrl, offerData, options).map((response: any) => {

            const result = response.json();
            return result;
        });
    }

    savePanHashForAutoRenewal(){
        
    }
}



// WEBPACK FOOTER //
// D:/Projects/Embla/dev/shop.embla.no/client.shop.embla.no/src/app/payment-gateway/services/payment.service.ts